import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import Card from '../card'
import SvgIconInfoBlue from '../../../assets/icon-info-blue.svg'
import { PrimaryButton, TernaryButton } from '../button/button.styled'
import TextArea from '../textarea'
// import { t } from 'i18next'
import Error from '../error'
import useSubmitApproval from '../../../hooks/useSubmitApproval'

const StyledFeedStatusAction = styled.div`
  > div:first-child {
    display: flex;
    img {
      margin-right: 18px;
    }
    p {
      font-weight: 700;
      font-size: 14px;
    }
  }

  > div.buttons {
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }

  textarea {
    width: calc(100% - 78px);
    margin-top: 6px;
    margin-left: 38px;
  }
`

interface IFeedStatusProps {
  createdAt: string
}

const FeedStatus: React.FC<IFeedStatusProps> = (props) => {
  const { createdAt } = props
  const { t } = useTranslation()
  const [note, setNote] = useState('')
  const [isError, setIsError] = useState(false)

  const approve = useSubmitApproval()

  const handleAcceptedPatient = (e: React.MouseEvent) => {
    e.preventDefault()
    approve.mutate({
      approve: true,
    })
  }

  const handleRejectedPatient = (e: React.MouseEvent) => {
    e.preventDefault()

    if (!note) {
      setIsError(true)
      return
    }

    approve.mutate({
      approve: false,
      note,
    })

    setNote('')
  }

  return (
    <Card date={createdAt}>
      <StyledFeedStatusAction>
        <div>
          <img src={SvgIconInfoBlue} alt='icon-info-blue' />
          <p>{t('feedStatus.patientRequestedMembership')}</p>
        </div>
        <TextArea
          placeholder={t('general.addNote')}
          labelId=''
          onChangeHandler={(e) => setNote(e)}
          value={note}
        />
        {isError && <Error>{t('newRequest.patientRejected')}</Error>}
        <div className='buttons'>
          <TernaryButton type='button' style={{ marginRight: 16 }} onClick={handleRejectedPatient}>
            {t('general.reject')}
          </TernaryButton>
          <PrimaryButton type='button' onClick={handleAcceptedPatient}>
            {t('general.accept')}
          </PrimaryButton>
        </div>
      </StyledFeedStatusAction>
    </Card>
  )
}

export default FeedStatus
